import dynamic from "next/dynamic";

export function IconRenderer({ icon, className = "", ...props }) {
  if (!icon) return null;

  // Normalize icon path, e.g. "social/facebook.svg"
  const cleanedPath = icon.replace(/\.svg$/, "");

  const DynamicIcon = dynamic(() =>
    import(`../../packages/icons/${cleanedPath}.svg`).catch(() => () => null)
  );

  return <DynamicIcon className={className} {...props} />;
}